import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState } from 'react';
import FormInput from '../../../../components/Form/FormInput';
import { CONSTANT } from '../../../../utils/constants';
import { confirmDialog } from 'primereact/confirmdialog';

function DateManager({ isOpen, date, onUpdate, loading, onCreate, onClose, handleDelete }) {
  const [dateConfig, setDateConfig] = useState(undefined);
  const [type, setType] = useState('');
  const [schedule, setSchedule] = useState('');
  const [details, setDetails] = useState('');

  useEffect(() => {
    if (date) {
      setType(date.type);
      setDateConfig(new Date(date.date));
      setSchedule(date.schedule);
      setDetails(date.details);
    } else {
      setDateConfig(undefined);
      setType('');
      setSchedule(undefined);
      setDetails(undefined);
    }
  }, [date]);

  const handleValidate = () => {
    const datePayload = {
      type,
      date: dateConfig,
      schedule,
      details
    };
    date ? onUpdate(datePayload) : onCreate(datePayload);
  };

  const formIsValid = () => {
    return dateConfig && type && schedule;
  };

  const confirmDeletion = (event) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cet Évènement ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      acceptClassName: 'bg-red-500 border-red-500',
      accept: () => handleDelete(event)
    });
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'delete'}
        label={'Supprimer le rendez-vous'}
        className="w-full"
        outlined
        onClick={() => confirmDeletion(date)}
        severity="danger"
      />
      <Button
        key={'validate'}
        label={`Valider la ${date ? 'modification' : 'création'}`}
        className="w-full"
        onClick={handleValidate}
        severity="success"
        disabled={!formIsValid()}
        loading={loading}
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 700 }}
      visible={isOpen}
      position="right"
      onHide={onClose}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`${date ? 'Modifier' : 'Ajouter'} un rendez-vous D-Code`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="form-wrapper">
          <FormInput key="type" label={'Type de rendez-vous'} required isValid={type}>
            <Dropdown
              value={type}
              options={CONSTANT.quatrebis.dateType}
              optionLabel="label"
              onChange={(e) => setType(e.value)}
              placeholder="Indiquez le type de rendez-vous D-code"
              className="grow"
            />
          </FormInput>

          <FormInput key="date" label={'Date'} required isValid={dateConfig}>
            <Calendar
              id="date"
              onChange={(e) => setDateConfig(e.value)}
              placeholder="Selectionnez une date"
              value={dateConfig}
              locale="fr"
            />
          </FormInput>

          <FormInput
            key="schedule"
            label={'Horaires'}
            helpMessage="Max. 50 caractères"
            required
            isValid={schedule}>
            <InputText
              id="schedule"
              value={schedule}
              maxLength={50}
              placeholder="Veuillez saisir les horaires du rendez-vous (ex: 14h - 18h)"
              onChange={(e) => setSchedule(e.target.value)}
            />
          </FormInput>
          <FormInput key="details" label={'Détails'} helpMessage="Max. 200 caractères">
            <InputText
              id="schedule"
              value={details}
              maxLength={200}
              placeholder="Précisez le détail du rendez-vous(ex: adresse, sur rendez-vous...)"
              onChange={(e) => setDetails(e.target.value)}
            />
          </FormInput>
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default DateManager;
